import React from 'react';

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  circle?: boolean;
  count?: number;
  className?: string;
}

/**
 * Tailwind-based skeleton loader component (replaces react-loading-skeleton)
 * Uses Tailwind's animate-pulse utility for the loading animation
 */
export default function Skeleton({ 
  width, 
  height, 
  circle = false, 
  count = 1,
  className = '' 
}: SkeletonProps) {
  const baseClasses = 'bg-gray-200 dark:bg-gray-700 animate-pulse rounded';
  
  const style: React.CSSProperties = {};
  if (width) {
    if (typeof width === 'number') {
      style.width = `${width}px`;
    } else {
      style.width = width;
    }
  }
  if (height) {
    if (typeof height === 'number') {
      style.height = `${height}px`;
    } else {
      style.height = height;
    }
  }
  
  const shapeClasses = circle ? 'rounded-full' : 'rounded';
  const combinedClasses = `${baseClasses} ${shapeClasses} ${className}`.trim();
  
  if (count > 1) {
    return (
      <>
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className={combinedClasses}
            style={index === count - 1 ? style : { ...style, marginBottom: '0.5rem' }}
          />
        ))}
      </>
    );
  }
  
  return (
    <div
      className={combinedClasses}
      style={style}
    />
  );
}
